import { object, string, number } from 'yup'

export const positionValidationSchema = (isRequired: boolean) =>
  object({
    positionName: string()
      .required('Debe ingresar un nombre para la posición')
      .min(1, 'Debe ingresar al menos 1 carácter')
      .max(50, 'Debe ingresar como máximo 50 carácteres')
      .matches(
        /^\s*[^a-z^\s*]+$/,
        'Nombre de posición acepta solo mayúsculas,sin espacios'
      ),
    positionDescription: string()
      .trim()
      .min(1, 'Debe ingresar a lo menos 3 caracteres')
      .max(200, 'Máximo 200 caracteres.'),
    typePositionId: number()
      .required('Debe seleccionar un tipo de posición')
      .min(1, 'Debe seleccionar un tipo de posición'),
    warehouseId: number()
      .required('Debe seleccionar un almacén')
      .min(1, 'Debe seleccionar un almacén'),
    // Campo nuevo con validación condicional
    zoneId: number().when([], {
      is: () => isRequired, // Se valida si el parámetro isRequired es true
      then: number().required('Tipo de Ubicación Requiere Zona'),
      otherwise: number() // Si isRequired es false, el campo no es obligatorio
    })
  })

export const crudActions = {
  canRedirect: false
}
